import styled from 'styled-components'

export const Container = styled.div`
    position: relative;
    margin-left: auto;
    margin-right: 10px;
`
